import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import Navbar from './component/Navbar';
import Footer from './component/Footer';

class HelpPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qesNo: 1
        }
    }
    handleDropAns = (num) => {

        if (this.state.qesNo === num) {
            this.setState({
                qesNo: 0
            })
        } else {
            this.setState({
                qesNo: num
            })
        }
    }
    render() {
        return (
            <div style={{ backgroundColor: "#060816", color: "#FFFFFF", minHeight: "100vh" }}>
                <Navbar />
                <div className="ht-container" style={{ paddingTop: "140px", paddingBottom: "80px" }}>
                    <div className="glass-card" style={{ padding: "48px", borderRadius: "24px", background: "rgba(15, 23, 42, 0.75)", border: "1px solid rgba(108, 99, 255, 0.3)" }}>
                        <div className='help-header' style={{ textAlign: "center", marginBottom: "36px" }}>
                            <h1 className='text-gradient' style={{ fontSize: "2.5rem", fontWeight: 800 }}>HungryTop Technologies - Help & FAQ</h1>
                            <p className='help-para' style={{ color: "#A3A8B8", fontSize: "1.05rem", maxWidth: "700px", margin: "12px auto 0 auto" }}>
                                Find answers to common questions regarding enterprise software platforms, PaperLoan lending, and HungryTop commerce.
                            </p>
                        </div>
                    <div className='q-ans'>
                        <h3 className='q-title'>Questions And Answers :</h3>
                        <div>
                            <div class="card mb-2">
                                <div class="card-header" onClick={(e) => this.handleDropAns(1)}>
                                    <h5 class="mb-0">
                                        Q : How To Participate in the Food Auction?
                                    </h5>
                                </div>

                                <div style={this.state.qesNo === 1 ? { display: "block" } : { display: "none" }}>
                                    <div class="card-body">
                                        Welcome To the Most Thrilling food bidding experience only at Hungry Top. Hungry Top is the World's First Food Auction Platform.
                                        To participate at the food auction, please Subscribe from the Profile Section of the Hungry Top App.
                                        Choose the Subscription Plan that suits you the best.
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-2">
                                <div class="card-header" onClick={(e) => this.handleDropAns(2)}>
                                    <h5 class="mb-0">
                                        Q : Way Of Engagement At The Food Auction?
                                    </h5>
                                </div>

                                <div style={this.state.qesNo === 2 ? { display: "block" } : { display: "none" }}>
                                    <div class="card-body">
                                        After you have taken subscription plan follow the steps below. Click on the Auction icon.
                                        Participate for your favorite food/restaurant available.
                                        Bid the amount you want to enter.
                                        And Win your food being the Top Bidder.
                                        Once you win an auction in a day, you cannot participate on the same day again at the auction again..
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-2">
                                <div class="card-header" onClick={(e) => this.handleDropAns(3)}>
                                    <h5 class="mb-0">
                                        Q : What are the rules and norms of the Food Auction?
                                    </h5>
                                </div>

                                <div style={this.state.qesNo === 3 ? { display: "block" } : { display: "none" }}>
                                    <div class="card-body">
                                        Once you win the auction either you order or not you won’t get a chance to play again at the auction on the same day
                                        Winners will get the food added to their cart respective cart section where they can place the order at their own bid price.
                                        All participants except the winners will get a special discount coupon through notifications after the auction is over, where they can avail a deep discount on the same food item that they bid for and enjoy their food.
                                        Kind attention to all auction winners: the auction items(food) is a promotional item from restaurant side. We request you all to order it within the stipulated time given. We have introduced the timer for that reason only.
                                        For all takeaway orders, please try to collect it within an hour of placing the order. Otherwise, it is at the discretion of the merchant to reject/accept latecomers. Auction orders are non-refundable once customer placed their order.
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-2">
                                <div class="card-header" onClick={(e) => this.handleDropAns(4)}>
                                    <h5 class="mb-0">
                                        Q : What are taxes and charges applicable on food orders? 
                                    </h5>
                                </div>

                                <div style={this.state.qesNo === 4 ? { display: "block" } : { display: "none" }}>
                                    <div class="card-body">
                                    GST will be applicable across all food orders placed at Hungry Top Platform as per Government norms . Delivery Charges, Packaging Charges are applicable as per restaurant discretion.
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-2">
                                <div class="card-header" onClick={(e) => this.handleDropAns(5)}>
                                    <h5 class="mb-0">
                                        Q : How to Contact Us
                                    </h5>
                                </div>

                                <div style={this.state.qesNo === 5 ? { display: "block" } : { display: "none" }}>
                                    <div class="card-body">
                                    Write us on this Email: <em>support@hungrytop.in</em>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='help-footer' style={{ marginTop: '48px', paddingTop: '32px', borderTop: '1px solid rgba(255, 255, 255, 0.08)', textAlign: 'center' }}>
                        <h4 style={{ color: '#FFF', fontSize: '1.4rem', fontWeight: 700, marginBottom: '20px' }}>Need more help?</h4>
                        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
                            <a
                                href='tel:6289096774'
                                className="glass-card"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '14px',
                                    padding: '14px 24px',
                                    borderRadius: '16px',
                                    textDecoration: 'none',
                                    border: '1px solid rgba(108, 99, 255, 0.4)',
                                    background: 'rgba(108, 99, 255, 0.12)',
                                }}
                            >
                                <FontAwesomeIcon icon={faPhone} style={{ color: '#00D4FF', fontSize: '1.2rem' }} />
                                <div style={{ textAlign: 'left' }}>
                                    <span style={{ fontSize: '0.75rem', color: '#A3A8B8', display: 'block', textTransform: 'uppercase', fontWeight: 600 }}>Call Support</span>
                                    <span style={{ fontSize: '1rem', fontWeight: 800, color: '#FFF' }}>+91 6289096774</span>
                                </div>
                            </a>

                            <a
                                href='mailto:support@hungrytop.in'
                                className="glass-card"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '14px',
                                    padding: '14px 24px',
                                    borderRadius: '16px',
                                    textDecoration: 'none',
                                    border: '1px solid rgba(0, 212, 255, 0.4)',
                                    background: 'rgba(0, 212, 255, 0.12)',
                                }}
                            >
                                <FontAwesomeIcon icon={faEnvelope} style={{ color: '#A78BFA', fontSize: '1.2rem' }} />
                                <div style={{ textAlign: 'left' }}>
                                    <span style={{ fontSize: '0.75rem', color: '#A3A8B8', display: 'block', textTransform: 'uppercase', fontWeight: 600 }}>Email Support</span>
                                    <span style={{ fontSize: '1rem', fontWeight: 800, color: '#FFF' }}>support@hungrytop.in</span>
                                </div>
                            </a>
                        </div>
                    </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default HelpPage;
